
<div class="month-calendar-cont">
  <div class="month-calendar">
    <el-button-group class="calendar-header">
      <el-button class="calendar-header-action prev" @click="prevMonth" icon="el-icon-arrow-left"></el-button>
      <el-button class="calendar-header-date">{{ displayMonthYear }}</el-button>
      <el-button class="calendar-header-action next" @click="nextMonth" icon="el-icon-arrow-right"></el-button>
    </el-button-group>
    <div class="weekdays">
      <div class="weekday" v-for="day in weekDays" :key="day">{{ day }}</div>
    </div>
    <el-skeleton :loading=isLoadingDays animated class="calendar-grid-cont">
      <template slot="template">
        <div class="calendar-grid">
          <el-skeleton-item class="day-loading" v-for="day in daysInMonth" :key="day.date.format('DD-MM-YYYY')" />
        </div>
      </template>
      <template>
        <div class="calendar-grid" style="display: grid; grid-template-columns: repeat(7, 1fr); gap: 8px;">
          <el-button @click="miniCalDateChoosed(day.date)" class="day" :disabled="isDisabled(day.date)"
            v-for="day in daysInMonth" :key="day.date.format('DD-MM-YYYY')"
            :class="{ 'disabled': isDisabled(day.date), 'notInMonth': !day.isCurrentMonth, }">
            <div class="calendar-grid-day">
              {{ day.date.date() }}
            </div>
            <div v-if="isDiscount(day.date)" class="discount-badge">
              <p>
                -{{ isDiscount(day.date) }}%
              </p>
            </div>
          </el-button>
        </div>
      </template>
    </el-skeleton>
  </div>
  <div v-if="getEventInfos" class="bookingMessage">
    <i class="el-icon-info"></i>
    <span class="bookingMessage-name">{{ getEventInfos.title }}</span><br />
    <span class="bookingMessage-text">{{ getEventInfos.desc }}</span>
  </div>
  <div v-if="getAllInfos.restoBookingMessage && getAllInfos.restoBookingMessage !== ''" class="bookingMessage">
    <i class="el-icon-info"></i>
    <span class="bookingMessage-text" v-html="renderMarkdown(getAllInfos.restoBookingMessage)"></span>
  </div>
</div>
